import React from 'react';

export const TypingIndicator = () => (
  <div style={{ display: 'flex', alignItems: 'center', height: 24 }}>
    {[0, 1, 2].map(i => (
      <span
        key={i}
        style={{
          display: 'inline-block',
          width: 8,
          height: 8,
          margin: '0 2px',
          borderRadius: '50%',
          background: '#9B7AEF',
          opacity: 0.7,
          animation: 'typing-bounce 1.2s infinite',
          animationDelay: `${i * 0.2}s`,
        }}
      />
    ))}
    <style>
      {`
        @keyframes typing-bounce {
          0%, 80%, 100% { transform: scale(0.7); opacity: 0.5; }
          40% { transform: scale(1); opacity: 1; }
        }
      `}
    </style>
  </div>
); 